import { MulticastDelegate } from '@Common/Core/MulticastDelegate';
import pointerHelper from '@Common/Helpers/PointerHelper';
import { BackgroundGradientStop } from '@InstanceFactory';
import { enumerable } from '@Common/Core/CoreDecorator';

export class GradientStopUnit {
    private readonly root: JQuery;
    private readonly onChanged: MulticastDelegate = new MulticastDelegate();
    private readonly onSelect: MulticastDelegate = new MulticastDelegate();

    @enumerable
    public get changedEvent(): MulticastDelegate {
        return this.onChanged;
    }

    @enumerable
    public get selectEvent(): MulticastDelegate {
        return this.onSelect;
    }

    constructor(private val: BackgroundGradientStop, private setting: { height: number; width: number }, private parent: JQuery) {
        this.root = this.createStopUnit();
        this.initDraggable(this.root);
        this.diactivate();
        this.update();
    }

    private initDraggable(root: JQuery): void {
        root.draggable({
            axis: 'x',
            containment: 'parent',
            cursor: 'pointer',
            scope: 'GradientStopUnit',
            helper: () => root,
            drag: () => {
                const offset = this.root.position().left / this.getColorsPanWidth();
                this.val.offset = Math.round(offset * 100) / 100;
                this.onChanged.fire(this);
            }
        });
    }

    private createStopUnit(): JQuery {
        return $('<div>')
            .addClass('gradientEditor-stop')
            .css({
                width: this.setting.width + 'px',
                height: this.setting.height + 'px'
            })
            .on(pointerHelper.pointerDownEventName, () => {
                this.onSelect.fire(this);
            })
            .appendTo(this.parent);
    }

    private getColorsPanWidth(): number {
        return this.parent.innerWidth() - this.setting.width;
    }

    public getValue(): BackgroundGradientStop {
        return this.val;
    }

    public activate(): void {
        this.root.addClass('active');
        this.root.css({
            borderTop: '2px solid black',
            top: '-2px',
            height: this.setting.height + 2 + 'px'
        });
    }

    public diactivate(): void {
        this.root.removeClass('active');
        this.root.css({
            border: '1px solid silver',
            top: '0px',
            height: this.setting.height + 'px'
        });
    }

    public isActive(): boolean {
        return this.root.hasClass('active');
    }

    public update(): void {
        this.root.css('left', this.val.offset * this.getColorsPanWidth() + 'px');
        this.root.css('background-color', this.val.color);
    }

    public remove(): void {
        this.root.remove();
    }
}
